webpackJsonp([73],{

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1282);


/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _ja = __webpack_require__(792);

var _ja2 = _interopRequireDefault(_ja);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('ja', _ja2.default);

/***/ })

},[1281]);


// WEBPACK FOOTER //
// app/datetime.ja-c62877932379b77c37fa.js